import { Box, Button, makeStyles } from '@material-ui/core';
import React from 'react';
import { useDispatch } from 'react-redux';
import { RootState, useSelector } from 'src/store';
import Plus from 'src/components/Icon/Plus';
import Minus from 'src/components/Icon/Minus';
import { editBtnAgain, editBtnText } from 'src/store/modules/buttons';
import { editTracking } from 'src/store/modules/trackings';

const useStyles = makeStyles(() => ({
  wrapper: {
    padding: '20px 16px 0 16px',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    backgroundColor: '#FFFFFF'
  },
  editor: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  title: {
    color: '#191F28',
    textAlign: 'center',
    fontFamily: "'Poppins', sans-serif",
    fontSize: '13px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: 'normal',
    letterSpacing: '0.02em'
  },
  scrollNumber: {
    margin: 'auto',
    overflowX: 'auto',
    display: 'flex',
    gap: '8px'
  },

  numberBox: {
    maxWidth: '32px',
    minWidth: '32px',
    maxHeight: '32px',
    minHeight: '32px',
    color: '#191F28',
    fontFamily: "'Poppins', sans-serif",
    fontSize: '13px',
    fontWeight: 400,
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    backgroundColor: '#F2F3F5',
    borderRadius: '6px',
    border: '1px solid #E5E8EB',
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: '#E5E8EB'
    }
  },

  addSubtract: {
    width: '100%',
    height: '44px',
    padding: '8px 12px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    background: '#191F28',
    borderRadius: '8px'
  },
  btnMinusPlus: {
    maxWidth: '32px',
    minWidth: '32px',
    maxHeight: '32px',
    minHeight: '32px',
    padding: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '6px',
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.1)'
    }
  },
  text: {
    color: '#FFFFFF',
    textAlign: 'center',
    fontFamily: "'Poppins', sans-serif",
    fontSize: '13px',
    fontStyle: 'normal',
    fontWeight: 600,
    letterSpacing: '0.02em'
  },
  slideRight: {
    color: '#8B95A1',
    textAlign: 'right',
    fontFamily: "'Poppins', sans-serif",
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: 'normal'
  }
}));

const EditMultiOption = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const currentIndex = useSelector(
    (state: RootState) => state.imageUpload.currentIndex
  );
  const btnText = useSelector((state: RootState) => state.buttons.btnText);
  const btnAgain = useSelector((state: RootState) => state.buttons.btnAgain);

  const tracking = useSelector((state: RootState) => state.trackings.tracking);

  const datas = btnText?.multi_action_survey?.[currentIndex]?.length;

  const handleDatas = (tf: boolean) => {
    const newBtnText = JSON.parse(JSON.stringify(btnText));
    const newTracking = JSON.parse(JSON.stringify(tracking));
    const btnText_len = newBtnText.multi_action_survey[currentIndex].length;
    const tracking_len = newTracking.multi_action_survey[currentIndex].length;
    if (tf) {
      newBtnText.multi_action_survey[currentIndex][btnText_len] =
        newBtnText.multi_action_survey[currentIndex][btnText_len - 1];
      newTracking.multi_action_survey[currentIndex][
        tracking_len
      ] = `option ${currentIndex + 1}-${tracking_len + 1}`;
    } else {
      newBtnText.multi_action_survey[currentIndex].pop();
      newTracking.multi_action_survey[currentIndex].pop();
    }
    dispatch(editBtnText(newBtnText));
    dispatch(editTracking(newTracking));

    const newBtnAgain = JSON.parse(JSON.stringify(btnAgain));
    const btnAgain_len =
      newBtnAgain?.['multi_action_survey']?.[currentIndex]?.length;
    newBtnAgain.multi_action_survey[currentIndex][btnAgain_len] =
      newBtnAgain?.['multi_action_survey']?.[currentIndex]?.[btnAgain_len - 1];
    dispatch(editBtnAgain(newBtnAgain));
  };

  return (
    <Box className={classes.wrapper}>
      <Box className={classes.addSubtract}>
        <Button
          className={classes.btnMinusPlus}
          disabled={datas === 2}
          onClick={() => handleDatas(false)}
        >
          <Minus stroke="#fff" />
        </Button>
        <span className={classes.text}>OPTION</span>
        <Button
          className={classes.btnMinusPlus}
          disabled={datas === 5}
          onClick={() => handleDatas(true)}
        >
          <Plus stroke="#fff" />
        </Button>
      </Box>
      <span className={classes.slideRight}>
        Choose from 2 to 5 question options
      </span>
    </Box>
  );
};

export default EditMultiOption;
